import React, { useState } from 'react'
import "./Loginscreen.css";
import SignUpScreen from './SignUpScreen';


function Login() {
  const [signIn, setSignIn] = useState(false);
  return (
    <div className='login-screen'>
      <div className='login-screen-background'>
        <img className='login-screen-logo' src='https://images.ctfassets.net/y2ske730sjqp/6bhPChRFLRxc17sR8jgKbe/6fa1c6e6f37acdc97ff635cf16ba6fb3/Logos-Readability-Netflix-logo.png' alt=""
        />
        <button onClick={() => setSignIn(true)}
         className='login-screen-button'>Sign In</button>
        <div className='login-screen-gradient'/>
      </div>

      <div className='login-screen-body'>
        {signIn ? (
         <SignUpScreen /> 
        ) : (
          <>
          <h1>Unlimited Films, TV Programmes and More.</h1>
          <h2>Watch Anywhere. Cancel at Anytime.</h2>
          <h3>Ready to Watch? Enter your Email to Create or Restart your Membership</h3>
  
          <div className='login-screen-input'>
            <form>
              <input type='email' placeholder="Email Address"/>
              <button onClick={() => setSignIn(true)}
               className='login-screen-get-started'>Get Started</button>
            </form>
          </div>
          </>)}
        
      </div>
      
    </div>
  )  
}

export default Login
